import React, { useState } from "react";
import Sidebar from "./Sidebar";
import { Menu } from "lucide-react";

export default function Layout({
  children,
  user,
  activeTab,
  setActiveTab,
  hasAccess,
  logout,
  modoClassico,
  toggleModoClassico
}) {
  return (
    <div className="flex flex-col h-screen w-full bg-slate-50 overflow-hidden">
      {/* Navbar de Topo (Antiga Sidebar) */}
      <Sidebar
        user={user}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        hasAccess={hasAccess}
        logout={logout}
        modoClassico={modoClassico}
        toggleModoClassico={toggleModoClassico}
      />

      {/* Conteúdo Principal */}
      <main className="flex-1 overflow-hidden w-full relative">
        <div className="w-full h-full">
          {children}
        </div>
      </main>
    </div>
  );
}
